// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainScreen-module__wrapper___VWbmQ {
  display: flex;
  width: 100%;
  max-width: 1238px;
  padding: 100px 60px;
  justify-content: space-between;
  align-items: center;
  border-radius: 42px;
  background: var(--color-element-bg);
}

.MainScreen-module__content___wrnqT {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 60px;
}

.MainScreen-module__cose___xWmIh{
  display: flex;
  justify-content: space-between;
  align-self: stretch;
  align-items: flex-start;
}

.MainScreen-module__casket___kCAX0{
  display: grid;
  grid-gap: 60px;
  gap: 60px;
}

.MainScreen-module__image___vWIL1 {
  max-width: 440px;
  max-height: 564px;
}

.MainScreen-module__image___vWIL1 img {
  width: 100%;
  height: 100%;
}

.MainScreen-module__title___BEztP {
  font: var(--font-h1);
  color: var(--color-black);
}

.MainScreen-module__title___BEztP span {
  color: var(--color-primary);
}

.MainScreen-module__text___Wzpeu {
  font: var(--font-main-max);
  color: var(--color-black);
  margin-top: 30px;
  width: 579px;
}

.MainScreen-module__link___CXlpa{
  font: var(--font-main-max);
  color: var(--color-primary);
  -webkit-text-decoration: none;
  text-decoration: none;
  transition: all 0.5s ease;
  cursor: pointer;
}
.MainScreen-module__link___CXlpa:hover{
  color: var(--color-black); 
}

.MainScreen-module__cover___xlRnc{
  display: flex;
  align-items: flex-end;
  -webkit-text-decoration: none;
  text-decoration: none;
  gap: 394px;
  width: 1118px;
  height: 128px;
  border-radius: 20px;
  background: #FFF;
  background: var(--surface, #FFF);
  }
  
  .MainScreen-module__container___L9q1v{
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 30px;
  padding-top: 30px;
  padding-left: 40px;
  }
  
  .MainScreen-module__bonus___bM4NA{
    display: flex;
    gap: 5px;
  }
  
  .MainScreen-module__laureate___iJs8W{
    color: #0E0E0E;
    color: var(--black, #0E0E0E);
    font-family: Inter;
    font-size: 30px;
    font-weight: 600;
  }
  
  .MainScreen-module__runet___aEH17{
    color: #41C4C4;
    color: var(--primary, #41C4C4);
    font-family: Inter;
    font-size: 30px;
    font-weight: 600;
  }
  
  .MainScreen-module__ru___t2hRR{
    color: #41C4C4;
    color: var(--primary, #41C4C4);
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
     text-decoration-line: underline;
  }
  
  .MainScreen-module__img___rv5Np{
  width: 163px;
  height: 148px;
  }
  
  .MainScreen-module__imgs___lWwLN{
    width: 100%;
    height: 100%;
  }

  .MainScreen-module__imgTel___Iq65j{
    display: none;
  }

  .MainScreen-module__indent___gpyHq{
    display: flex;
    gap: 16px;
    flex-direction: column;
  }

  .MainScreen-module__word___Zfcua {
    font: var(--font-main-max);
    color: var(--color-black);
    font-weight: 500;
  }

@media (min-width: 768px) and (max-width: 1199px) {

  .MainScreen-module__cose___xWmIh{
    display: flex;
    align-items: center;
    gap: 30px;
  }

  .MainScreen-module__casket___kCAX0{
    width: 314px;
    gap: 40px;
  }

  .MainScreen-module__wrapper___VWbmQ {
    width: 698px;
    padding: 60px 30px 30px 30px;
    gap: 30px;
  }

  .MainScreen-module__content___wrnqT {
    gap: 40px;
    width: 314px;
  }

  .MainScreen-module__image___vWIL1 {
    display: flex;
    flex-shrink: 0;
    max-width: 293px;
    max-height: 375px;
  }

  .MainScreen-module__text___Wzpeu {
    width: 323px;
  }

  .MainScreen-module__link___CXlpa{
    width: 323px;
    -webkit-text-decoration: none;
    text-decoration: none;
  }

  .MainScreen-module__cover___xlRnc{
    width: 632px;
    height: 83px;
    gap: 213px;
    }
    
    .MainScreen-module__container___L9q1v{
      gap: 4px;
      padding-bottom: 20px;
      padding-top: 20px;
      padding-left: 20px;
    }
    
    .MainScreen-module__laureate___iJs8W{
      font-size: 18px;
    }
    
    .MainScreen-module__runet___aEH17{
      font-size: 18px;
    }
    
    .MainScreen-module__ru___t2hRR{
      font-size: 14px;
    }
    
    .MainScreen-module__img___rv5Np{
      width: 108px;
      height: 96px;
    }

    .MainScreen-module__imgTel___Iq65j{
      display: none;
    }
}

@media (min-width: 360px) and (max-width: 767px) {

  .MainScreen-module__wrapper___VWbmQ {
    width: 324px;
    padding: 30px 18px;
    gap: 25px;
    flex-direction: column;
  }

  .MainScreen-module__cose___xWmIh{
    flex-direction: column;
    gap: 25px;
  }

  .MainScreen-module__content___wrnqT {
    gap: 40px;
  }

  .MainScreen-module__casket___kCAX0{
    display: flex;
    width: 288px;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .MainScreen-module__image___vWIL1 {
    max-width: 287px;
    max-height: 368px;

  }

  .MainScreen-module__title___BEztP {
    text-align: center;
  }

  .MainScreen-module__text___Wzpeu {
    margin-top: 16px;
    width: 295px;
  }


  .MainScreen-module__cover___xlRnc{
    display: flex;
width: 288px;
height: 140px;
padding: 20px 0px 0px 16px;
justify-content: center;
align-items: flex-start;
gap: 16px;
border-radius: 20px;
background: #FFF;
background: var(--surface, #FFF);
    }
    
    .MainScreen-module__container___L9q1v{
      gap: 16px;
      padding-bottom: 0px;
      padding-top: 0px;
      padding-left: 0px;
    }
    
    .MainScreen-module__bonus___bM4NA{
     gap: 3px;
     flex-direction: column;
     width: 136px;
    }
    
    .MainScreen-module__laureate___iJs8W{
      font-size: 18px;
    }
    
    .MainScreen-module__runet___aEH17{
      font-size: 18px;
    }
    
    .MainScreen-module__ru___t2hRR{
      font-size: 14px;
    }
    
    .MainScreen-module__img___rv5Np{
     display: none;
    }

    .MainScreen-module__imgTel___Iq65j{
      display: flex;
      width: 120px;
      height: 120px;
    }

    .MainScreen-module__imgsTel___EysuW{
      width: 100%;
      height: 100%;
    }

}`, "",{"version":3,"sources":["webpack://./src/widgets/mainScreen/ui/MainScreen.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAAqB;EAArB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAAqB;EAArB,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgC;EAAhC,gCAAgC;EAChC;;EAEA;EACA,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,cAA4B;IAA5B,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAA8B;IAA9B,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAA8B;IAA9B,8BAA8B;EAChC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;KACb,+BAA+B;EAClC;;EAEA;EACA,YAAY;EACZ,aAAa;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,gBAAgB;EAClB;;AAEF;;EAEE;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,4BAA4B;IAC5B,SAAS;EACX;;EAEA;IACE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,6BAAqB;IAArB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,UAAU;IACV;;IAEA;MACE,QAAQ;MACR,oBAAoB;MACpB,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,aAAa;IACf;AACJ;;AAEA;;EAEE;IACE,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;;EAEnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;;EAGA;IACE,aAAa;AACjB,YAAY;AACZ,aAAa;AACb,0BAA0B;AAC1B,uBAAuB;AACvB,uBAAuB;AACvB,SAAS;AACT,mBAAmB;AACnB,gBAAgC;AAAhC,gCAAgC;IAC5B;;IAEA;MACE,SAAS;MACT,mBAAmB;MACnB,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;KACC,QAAQ;KACR,sBAAsB;KACtB,YAAY;IACb;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;KACC,aAAa;IACd;;IAEA;MACE,aAAa;MACb,YAAY;MACZ,aAAa;IACf;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;AAEJ","sourcesContent":[".wrapper {\n  display: flex;\n  width: 100%;\n  max-width: 1238px;\n  padding: 100px 60px;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 42px;\n  background: var(--color-element-bg);\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 60px;\n}\n\n.cose{\n  display: flex;\n  justify-content: space-between;\n  align-self: stretch;\n  align-items: flex-start;\n}\n\n.casket{\n  display: grid;\n  gap: 60px;\n}\n\n.image {\n  max-width: 440px;\n  max-height: 564px;\n}\n\n.image img {\n  width: 100%;\n  height: 100%;\n}\n\n.title {\n  font: var(--font-h1);\n  color: var(--color-black);\n}\n\n.title span {\n  color: var(--color-primary);\n}\n\n.text {\n  font: var(--font-main-max);\n  color: var(--color-black);\n  margin-top: 30px;\n  width: 579px;\n}\n\n.link{\n  font: var(--font-main-max);\n  color: var(--color-primary);\n  text-decoration: none;\n  transition: all 0.5s ease;\n  cursor: pointer;\n}\n.link:hover{\n  color: var(--color-black); \n}\n\n.cover{\n  display: flex;\n  align-items: flex-end;\n  text-decoration: none;\n  gap: 394px;\n  width: 1118px;\n  height: 128px;\n  border-radius: 20px;\n  background: var(--surface, #FFF);\n  }\n  \n  .container{\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-bottom: 30px;\n  padding-top: 30px;\n  padding-left: 40px;\n  }\n  \n  .bonus{\n    display: flex;\n    gap: 5px;\n  }\n  \n  .laureate{\n    color: var(--black, #0E0E0E);\n    font-family: Inter;\n    font-size: 30px;\n    font-weight: 600;\n  }\n  \n  .runet{\n    color: var(--primary, #41C4C4);\n    font-family: Inter;\n    font-size: 30px;\n    font-weight: 600;\n  }\n  \n  .ru{\n    color: var(--primary, #41C4C4);\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 400;\n     text-decoration-line: underline;\n  }\n  \n  .img{\n  width: 163px;\n  height: 148px;\n  }\n  \n  .imgs{\n    width: 100%;\n    height: 100%;\n  }\n\n  .imgTel{\n    display: none;\n  }\n\n  .indent{\n    display: flex;\n    gap: 16px;\n    flex-direction: column;\n  }\n\n  .word {\n    font: var(--font-main-max);\n    color: var(--color-black);\n    font-weight: 500;\n  }\n\n@media (min-width: 768px) and (max-width: 1199px) {\n\n  .cose{\n    display: flex;\n    align-items: center;\n    gap: 30px;\n  }\n\n  .casket{\n    width: 314px;\n    gap: 40px;\n  }\n\n  .wrapper {\n    width: 698px;\n    padding: 60px 30px 30px 30px;\n    gap: 30px;\n  }\n\n  .content {\n    gap: 40px;\n    width: 314px;\n  }\n\n  .image {\n    display: flex;\n    flex-shrink: 0;\n    max-width: 293px;\n    max-height: 375px;\n  }\n\n  .text {\n    width: 323px;\n  }\n\n  .link{\n    width: 323px;\n    text-decoration: none;\n  }\n\n  .cover{\n    width: 632px;\n    height: 83px;\n    gap: 213px;\n    }\n    \n    .container{\n      gap: 4px;\n      padding-bottom: 20px;\n      padding-top: 20px;\n      padding-left: 20px;\n    }\n    \n    .laureate{\n      font-size: 18px;\n    }\n    \n    .runet{\n      font-size: 18px;\n    }\n    \n    .ru{\n      font-size: 14px;\n    }\n    \n    .img{\n      width: 108px;\n      height: 96px;\n    }\n\n    .imgTel{\n      display: none;\n    }\n}\n\n@media (min-width: 360px) and (max-width: 767px) {\n\n  .wrapper {\n    width: 324px;\n    padding: 30px 18px;\n    gap: 25px;\n    flex-direction: column;\n  }\n\n  .cose{\n    flex-direction: column;\n    gap: 25px;\n  }\n\n  .content {\n    gap: 40px;\n  }\n\n  .casket{\n    display: flex;\n    width: 288px;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n  }\n\n  .image {\n    max-width: 287px;\n    max-height: 368px;\n\n  }\n\n  .title {\n    text-align: center;\n  }\n\n  .text {\n    margin-top: 16px;\n    width: 295px;\n  }\n\n\n  .cover{\n    display: flex;\nwidth: 288px;\nheight: 140px;\npadding: 20px 0px 0px 16px;\njustify-content: center;\nalign-items: flex-start;\ngap: 16px;\nborder-radius: 20px;\nbackground: var(--surface, #FFF);\n    }\n    \n    .container{\n      gap: 16px;\n      padding-bottom: 0px;\n      padding-top: 0px;\n      padding-left: 0px;\n    }\n    \n    .bonus{\n     gap: 3px;\n     flex-direction: column;\n     width: 136px;\n    }\n    \n    .laureate{\n      font-size: 18px;\n    }\n    \n    .runet{\n      font-size: 18px;\n    }\n    \n    .ru{\n      font-size: 14px;\n    }\n    \n    .img{\n     display: none;\n    }\n\n    .imgTel{\n      display: flex;\n      width: 120px;\n      height: 120px;\n    }\n\n    .imgsTel{\n      width: 100%;\n      height: 100%;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `MainScreen-module__wrapper___VWbmQ`,
	"content": `MainScreen-module__content___wrnqT`,
	"cose": `MainScreen-module__cose___xWmIh`,
	"casket": `MainScreen-module__casket___kCAX0`,
	"image": `MainScreen-module__image___vWIL1`,
	"title": `MainScreen-module__title___BEztP`,
	"text": `MainScreen-module__text___Wzpeu`,
	"link": `MainScreen-module__link___CXlpa`,
	"cover": `MainScreen-module__cover___xlRnc`,
	"container": `MainScreen-module__container___L9q1v`,
	"bonus": `MainScreen-module__bonus___bM4NA`,
	"laureate": `MainScreen-module__laureate___iJs8W`,
	"runet": `MainScreen-module__runet___aEH17`,
	"ru": `MainScreen-module__ru___t2hRR`,
	"img": `MainScreen-module__img___rv5Np`,
	"imgs": `MainScreen-module__imgs___lWwLN`,
	"imgTel": `MainScreen-module__imgTel___Iq65j`,
	"indent": `MainScreen-module__indent___gpyHq`,
	"word": `MainScreen-module__word___Zfcua`,
	"imgsTel": `MainScreen-module__imgsTel___EysuW`
};
export default ___CSS_LOADER_EXPORT___;
